export default [
  {
    path: "/ai/resume",
    name: "AiResume",
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/ai/resume"),
  },
  {
    path: "/ai/resume/:token/preview",
    name: "AiResumePreview",
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/ai/preview"),
  },
  {
    path: "/ai/onboarding",
    name: "AiOnboarding",
    component: () =>
      import(/* webpackChunkName: "account" */ "@/views/ai/onboarding"),
  },
  // ai导师 - 简历报告
  {
    path: "/ai/mentor/:cv_token/report",
    name: "AiMentorReport",
    component: () =>
      import(/* webpackChunkName: "AiMentorReport" */ "@/views/aiMentor/report"),
  },
];
